// import { lazy } from "react";

// import Loadable from "../common/Loadable";

// project layouts

import PublicLayout from "../layout/customer/public";
import ProtectUserRoute from "../permissions/ProtectUserRoute";

// render - pages
import Landing from "../pages/Landing";
import Search from "../pages/Search";
import Saved from "../pages/design/Saved";
import Liked from "../pages/design/Liked";
import DesignLanding from "../pages/design/DesignLanding";
import Address from "../pages/address/Address";
import Basket from "../pages/buy/Basket";
import Order from "../pages/buy/Order";
import ViewBasket from "../pages/buy/ViewBasket";
import ViewOrder from "../pages/buy/ViewOrder";
import Ticket from "../pages/ticket/Ticket";
import TicketDetail from "../pages/ticket/TicketDetail";
import Category from "../pages/design/Category";

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  // element: <ProtectUserRoute />,
  children: [
    {
      path: "",
      element: <PublicLayout />,
      children: [
        {
          path: "",
          element: <Landing />,
        },
        {
          path: "search",
          element: <Search />,
        },
        {
          path: ":some",
          element: <Landing />,
        },
        {
          path: "basket/:id",
          element: <Basket />,
        },
        {
          path: "d/:id",
          element: <DesignLanding />,
        },
        {
          path: "c/:cat1/:cat2",
          element: <Category />,
        },
        {
          path: "c/:cat2",
          element: <Category />,
        },
      ],
    },
    {
      path: "",
      element: <ProtectUserRoute />,
      children: [
        {
          path: "saved",
          element: <Saved />,
        },
        {
          path: "likes",
          element: <Liked />,
        },
        {
          path: "address",
          element: <Address />,
        },
        {
          path: "basket",
          element: <ViewBasket />,
        },
        {
          path: "orders",
          element: <Order />,
        },
        {
          path: "order/:id",
          element: <ViewOrder />,
        },
        {
          path: "ticket",
          element: <Ticket />,
        },
        {
          path: "ticket/:id",
          element: <TicketDetail />,
        },
      ],
    },
  ],
};

export default MainRoutes;
